
export const DEFAULT_COLOR = '#c82953';

export function hasInventory({ item, showInventory = false }) {
  return showInventory
      && item.inventory_items
      && item.inventory_items.length > 0;
}
